import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryParams, UserQuizDate } from '../../types';
import { Paginated, PaginationService } from '../../services/api-handlers/pagination';
import UserQuizApi from '../../services/end-points/user-quiz-api';
import SortingService from '../../services/sorting';
import { ThunkConfig } from '../configure-store';

interface QueryParamsWithUserId extends QueryParams {
    userId: string;
}

export const listUserQuizzes = createAsyncThunk<Paginated<UserQuizDate>, QueryParamsWithUserId, ThunkConfig>(
    'user-quiz/list',
    async (payload, thunkAPI) => {
        const { getState } = thunkAPI;
        const { userQuiz } = getState();
        const { userId, filters, sorting, ...rest } = payload;

        return PaginationService.resolveApiCall(
            thunkAPI,
            userQuiz,
            async () =>
                UserQuizApi.list(userId, {
                    ...filters,
                    ...SortingService.makeOrder(sorting),
                    ...rest,
                }),
            payload.page,
            userQuiz.data,
        );
    },
);
